import { useCallback, useEffect, useState } from 'react';

import { createContainer } from 'unstated-next';

import { getUrlParams, parseUrlState } from '../utils/url';

const useAdminAuth = () => {
    const [userUuid, setUserUuid] = useState<null | string>(null);
    const { user_uuid: userUuidFromUrlParams } = getUrlParams();

    const getUuidFromParams = useCallback(() => {
        if (userUuidFromUrlParams) {
            return userUuidFromUrlParams;
        }
    }, [userUuidFromUrlParams]);

    const getUuidFromState = () => {
        const urlParams = new URLSearchParams(window.location.search);
        const state = urlParams.get('state');

        if (state) {
            const parsedState = parseUrlState(state);
            return parsedState.user_uuid;
        }

        return state;
    };

    useEffect(() => {
        const findUserUuid = () => {
            const userUuidFound = getUuidFromState() || getUuidFromParams() || window.localStorage.getItem('user_uuid') || null;

            if (userUuidFound) {
                window.localStorage.setItem('user_uuid', userUuidFound);
                window.localStorage.setItem('user_uuid_time', String((new Date()).getTime()));
            }

            return userUuidFound;
        };

        const foundUserUuid = findUserUuid();

        setUserUuid(foundUserUuid);
    }, [getUuidFromParams]);

    return { userUuid };
};

const AuthContainer = createContainer(useAdminAuth);

export default AuthContainer;
